import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/dropdown-selector-v1/dropdown-selector-v1-index';

@Injectable({
    providedIn: 'root'
})
export class DropdownSelectorV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'dropdown-selector-v1';
    menuTitle: string = "Dropdown Selector";
    deprecated: boolean = false;


    /**
      * 
      * @param field the object data of the field
      * @returns DropdownSelectorV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.SingleTagSelectorV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsDropdownSelectorV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsDropdownSelectorV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        const f =  new fields.SettingsDropdownSelectorV1Field(field.type, field.position);
        return f.deserialize(field);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsDropdownSelectorV1FieldComponent> {
        return fieldComponents.SettingsDropdownSelectorV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillDropdownSelectorV1FieldComponent> {
        return fieldComponents.FillDropdownSelectorV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewDropdownSelectorV1FieldComponent> {
        return fieldComponents.ViewDropdownSelectorV1FieldComponent;
    }
}

